import { STATUS } from './constants/statuses'
import {
  mapBackgroundCheckStatus,
  mapPATStatus,
  mapApplicationStatus,
  aggregateStatuses,
} from './statusMappers'

export const shouldExcludeRequirement = (reqKey, curriculumVersion) => {
  // Course manuals only exist in curriculum 3.1
  if (reqKey === 'course_manuals' && curriculumVersion !== '3.1') {
    return true
  }

  return false
}

export const resolveRequirementStatus = ({
  levelKey,
  reqKey,
  levelCode,
  data,
}) => {
  const {
    programRequirements,
    prospect,
    associateApplication,
    affiliateApplication,
    memberApplication,
    finalExamStatus,
  } = data

  // Qualifying Level Requirements
  if (levelKey === 'qualifying') {
    switch (reqKey) {
      case 'background_check':
        return mapBackgroundCheckStatus(prospect?.backgroundCheck?.status)

      case 'playing_ability_test':
        return mapPATStatus(
          prospect?.playingAbilityTest,
          prospect?.playingAbilityTestStatus,
        )

      case 'application': {
        // Use Associate or Affiliate application for Qualifying level
        const qualifyingApplication =
          associateApplication || affiliateApplication
        return mapApplicationStatus(qualifyingApplication)
      }

      case 'course_manuals': {
        // Find course manual requirements for this level
        const courseReqs = programRequirements.filter(
          (req) =>
            req.levelCode === levelCode &&
            req.requirementTypeKey === 'course_manuals',
        )
        return aggregateStatuses(courseReqs.map((r) => r.status))
      }

      default:
        return STATUS.READY
    }
  }

  // Level 3 Special Requirements
  if (levelKey === 'level3') {
    if (reqKey === 'final_exam') {
      return finalExamStatus || STATUS.READY
    }

    if (reqKey === 'enrollment') {
      return mapApplicationStatus(memberApplication)
    }
  }

  // Standard requirements for Levels 1, 2, and 3
  // Match by levelCode and requirementTypeKey
  const matchingReqs = programRequirements.filter(
    (req) => req.levelCode === levelCode && req.requirementTypeKey === reqKey,
  )

  // Aggregate the statuses (if no matching reqs, returns 'ready')
  return aggregateStatuses(matchingReqs.map((r) => r.status))
}
